/**
 * Lays out the children of every `.masonry` element in as many columns as its `--columns` CSS property says (see layout.scss), each onto the currently
 * shortest column, so they read row by row. Lays them out again only when a breakpoint changes the number of columns.
 */
export function addMasonryLayouts() {
    document.querySelectorAll('.masonry').forEach(masonry => {
        const items = [...masonry.children]
        let columnCount: number

        const layOut = () => {
            const count = Number(getComputedStyle(masonry).getPropertyValue('--columns'))
            if (count === columnCount) return
            columnCount = count

            const columns = Array.from({length: count}, () => {
                const column = document.createElement('div')
                column.className = 'masonry__column'
                return column
            })
            masonry.replaceChildren(...columns)
            masonry.classList.add('masonry--columns')
            items.forEach(item => columns.reduce((shortest, column) => column.offsetHeight < shortest.offsetHeight ? column : shortest).append(item))
        }

        layOut()
        addEventListener('resize', layOut)
    })
}
